import { ProfileMobileNavigation } from '@features/profile/components/side-navigation/mobile/ProfileMobileNavigation';
import * as React from 'react';

const ProfilePage = React.memo((): React.ReactElement => (
  <ProfileMobileNavigation />
));

ProfilePage.displayName = 'ProfilePage';

export { ProfilePage };
